import React from 'react';
import { Button } from './ui/button';

const MDVIPCallToAction = () => {
  return (
    <section className="py-16 bg-stone-700">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Experience Personalized Healthcare
        </h2>
        <p className="text-xl text-stone-100 mb-8">
          Join MDVIP to start your journey with Dr. Williams and Crofton Family Practice.
        </p>
        <a
          href="https://www.mdvip.com/doctors/allisonwilliamsmd"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button className="bg-gradient-to-r from-orange-400 via-amber-500 to-orange-600 hover:from-orange-500 hover:via-amber-600 hover:to-orange-700 text-white font-semibold px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300">
            Join MDVIP Today →
          </Button>
        </a>
      </div>
    </section>
  );
};

export default MDVIPCallToAction;
